import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import $ from 'jquery';
import Loading from '../component/Loading';

function AuthCallback() {
    const navigate = useNavigate();
    const { provider } = useParams();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('processing');
    const [message, setMessage] = useState('로그인 처리 중...');

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const siteCode = process.env.REACT_APP_SITE_CODE_LIGHTHOUSE;

    useEffect(() => {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (error) {
            setStatus('error');
            setMessage('로그인이 취소되었습니다.');
            setTimeout(() => navigate('/lighthouse'), 2000);
            return;
        }

        if (!code) {
            setStatus('error');
            setMessage('인증 코드가 없습니다.');
            setTimeout(() => navigate('/lighthouse'), 2000);
            return;
        }

        processLogin(code, state);
    }, []);

    const processLogin = (code, state) => {
        const redirectUri = `${window.location.origin}/lighthouse/auth/callback/${provider}`;

        let apiEndpoint = '';
        let requestData = {};

        if (provider === 'kakao') {
            apiEndpoint = `${API_BASE_URL}/kakaoLogin`;
            requestData = {
                code: code,
                redirect_uri: redirectUri,
                site_code: siteCode
            };
        } else if (provider === 'naver') {
            apiEndpoint = `${API_BASE_URL}/naverLogin`;
            requestData = {
                code: code,
                state: state,
                redirect_uri: redirectUri,
                site_code: siteCode
            };
        } else {
            setStatus('error');
            setMessage('지원하지 않는 로그인 방식입니다.');
            setTimeout(() => navigate('/lighthouse'), 2000);
            return;
        }

        $.ajax({
            url: apiEndpoint,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(requestData),
            headers: { APIKEY: APIKEY },
            success: function (res) {
                if (res.code === '0') {
                    localStorage.setItem('lighthouse_memberId', res.member_id);
                    localStorage.setItem('lighthouse_socialLoggedIn', 'true');

                    // 메인페이지에서 팝업 표시를 위해 저장
                    if (res.is_new) {
                        localStorage.setItem('lighthouse_authMessage', 'signup');
                    } else {
                        localStorage.setItem('lighthouse_authMessage', 'login');
                    }

                    // 바로 메인페이지로 이동
                    window.location.href = '/lighthouse';
                } else {
                    setStatus('error');
                    setMessage(res.msg || '로그인에 실패했습니다.');
                    setTimeout(() => navigate('/lighthouse'), 2000);
                }
            },
            error: function (xhr, status, err) {
                console.error('로그인 에러:', err);
                setStatus('error');
                setMessage('로그인 처리 중 오류가 발생했습니다.');
                setTimeout(() => navigate('/lighthouse'), 2000);
            }
        });
    };

    return (
        <div className="authCallbackPage" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '20px',
            textAlign: 'center'
        }}>
            {status === 'processing' && <Loading />}

            <div style={{
                marginTop: '20px',
                fontSize: '18px',
                color: status === 'error' ? '#ff6b6b' : status === 'success' ? '#51cf66' : '#fff'
            }}>
                {status === 'success' && <span style={{ marginRight: '8px' }}>&#10003;</span>}
                {status === 'error' && <span style={{ marginRight: '8px' }}>&#10007;</span>}
                {message}
            </div>
        </div>
    );
}

export default AuthCallback;
